import {Coordinate} from 'ol/coordinate';
import {Polygon} from 'ol/geom';
import {fromLonLat, toLonLat} from 'ol/proj';
import {fromJson, json, JsonMappers} from '../core/data-source/json.mapper';
import {TerritoryGroupRecord} from './territory-group.record';

export class TerritoryRecord {
    @json() aocId: number;

    @json({
        nullable: true,
        mapper: {
            to: (value: string, record: TerritoryRecord) => record?.name
        }
    })
    groupName: string;

    @json({
        jsonName: 'groupId',
        nullable: true,
        mapper: {
            from: (value: string, json: any) =>
                fromJson(TerritoryGroupRecord, {name: json.groupName, id: json.groupId}),
            to: (value: TerritoryGroupRecord) => value?.id
        }
    })
    group: TerritoryGroupRecord;

    @json() id: number;

    @json() name: string;

    @json() color: string;

    @json() externalId: string;

    @json({
        value: 1
    })
    coefficient: number;

    @json({
        mapper: {
            from: (data: any): Polygon => {
                if (data && data.length) {
                    let items: Coordinate[] = JSON.parse('[[' + data.replace(/\|/g, '],[') + ']]').map(
                        (coord: Coordinate) => fromLonLat(coord.reverse())
                    );
                    return new Polygon([items]);
                }
            },
            to: (polygon: Polygon): string =>
                polygon
                    .getCoordinates()[0]
                    .map((coord: Coordinate) => toLonLat(coord).reverse().join(', '))
                    .join('|')
        },
        jsonName: 'area'
    })
    polygon: Polygon;

    selected: boolean = false;
}
